import { isTodoFolderList, isTodoMyDayList, TodoListId, TodoListIdType } from 'owa-todo-list-types';
import { assertNever } from 'owa-assert';

export function isSameList(list1: TodoListId, list2: TodoListId) {
    if (isTodoMyDayList(list1)) {
        return list2.type === TodoListIdType.MyDay;
    } else if (isTodoFolderList(list1)) {
        return list2.type === TodoListIdType.Folder && list1.Id === list2.Id;
    }
    return assertNever(list1);
}
